import * as THREE from 'three'
import Experience from './Experience'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'
import CameraControls from "camera-controls";
import { gsap } from 'gsap';
import type Sizes from './Utils/Sizes';

export default class Camera{
    experience: Experience
    sizes: Sizes
    scene: THREE.Scene
    canvas: HTMLCanvasElement | null
    instance: THREE.PerspectiveCamera
    cameraControls!: CameraControls
    controls: OrbitControls | null
    paddingSprite: number
    paddingMesh: number
    _centerPosition: THREE.Vector3
    _normal: THREE.Vector3
    _cameraPosition: THREE.Vector3

    constructor(experience: Experience | undefined = undefined){
        this.experience= experience ?? new Experience()
        this.sizes= this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas ?? null
        this.instance = new THREE.PerspectiveCamera()
        this.controls = null
        this.paddingSprite = 0.5
        this.paddingMesh = 2
        this._centerPosition = new THREE.Vector3()
        this._normal = new THREE.Vector3()
        this._cameraPosition = new THREE.Vector3()
        this.setInstance()
        // this.setOrbitControls()
        this.setCameraControls()


    }
    setInstance(){
        const sizes = this.sizes;
        this.instance = new THREE.PerspectiveCamera(
            35,
            sizes.width/sizes.height,
            0.1,
            2000)
        this.instance.position.set(6,4,8)
        this.scene.add(this.instance)
    }
    setOrbitControls(){
        this.controls = new OrbitControls(this.instance,this.canvas)
        this.controls.enableDamping = true
    }
    setCameraControls(){
        CameraControls.install({THREE: THREE});
        this.cameraControls = new CameraControls(this.instance, this.canvas ?? undefined);
        this.cameraControls.smoothTime = .55

        // console.log(this.cameraControls);
        this._centerPosition = new THREE.Vector3();
        this._normal = new THREE.Vector3();
        this._cameraPosition = new THREE.Vector3();

    }
    getCameraControls(): CameraControls
    {
        return this.cameraControls
    }
    resetLookAtOrigin() {
        const cameraPosition = this.instance?.position;
        if (!cameraPosition) return;
        this.cameraControls.setLookAt(
            cameraPosition.x,
            cameraPosition.y,
            cameraPosition.z,
            0,
            0,
            0,
            true,
        );
    }
    resize(){
        const sizes = this.sizes;
        this.instance.aspect = sizes.width / sizes.height
        this.instance.updateProjectionMatrix()
    }
    update(){
        // this.controls.update()
        this.cameraControls.update(this.experience.time.delta) //for cameraControls to work
    }
    fitToRect(element: THREE.Object3D & { geometry?: { parameters?: { width?: number, height?: number } } }, spacing=this.paddingMesh)
    {
        const centerPosition = this._centerPosition || new THREE.Vector3();
        const normal = this._normal || new THREE.Vector3();
        const cameraPositionBuffer = this._cameraPosition || new THREE.Vector3();
        const elementWidth = element.geometry?.parameters?.width || 1;
        const elementHeight = element.geometry?.parameters?.height || 1;
        element.updateMatrixWorld();
        const elementCenterPosition = centerPosition.copy( element.position );
        const elementNormal = normal.set( 0, 0, -1 )
        // .applyQuaternion( element.quaternion );
        this.instance.updateMatrixWorld();
        // element.quaternion.set(0,0,0,1)
        const distance = this.cameraControls.getDistanceToFitBox( elementWidth*spacing, elementHeight*spacing, 0 );
        const cameraPosition = cameraPositionBuffer.copy( elementNormal ).multiplyScalar( - distance ).add( elementCenterPosition );

        this.cameraControls.setLookAt(
            cameraPosition.x, cameraPosition.y, cameraPosition.z,
            elementCenterPosition.x, elementCenterPosition.y, elementCenterPosition.z,
            true,
        );
    gsap.to(element.quaternion, {
        duration: 1,
        x: 0,
        y: 0,
        z: 0,
        w: 1,
        ease: "power2.out",
    });
    }
}   